import template   from './infos-product.html'
import controller from './infos-product.controller'
import './infos-product.styl'

let component = {
  restrict: 'E',
  bindings: {
    productRef: '<',
    voucherInfos: '=',
    isFreeProduct: '='
  },
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/my-purchase/infos-product/infos-product.component.js